import { getTopDomain, isMobile } from '@peerup/utils'

const {
  location: { host: HOST },
} = window

export const isDev = /localhost|\d+\.\d+\.\d+\.\d+/.test(HOST)

const toString = Object.prototype.toString

export function is(val: unknown, type: string) {
  return toString.call(val) === `[object ${type}]`
}

export function isDef<T = unknown>(val?: T): val is T {
  return typeof val !== 'undefined'
}

export function isUnDef<T = unknown>(val?: T): val is T {
  return !isDef(val)
}

export function isObject(val: any): val is Record<any, any> {
  return val !== null && is(val, 'Object')
}

export function isEmpty<T = unknown>(val: T): val is T {
  if (isArray(val) || isString(val)) {
    return val.length === 0
  }

  if (val instanceof Map || val instanceof Set) {
    return val.size === 0
  }

  if (isObject(val)) {
    return Object.keys(val).length === 0
  }

  return false
}

export function isDate(val: unknown): val is Date {
  return is(val, 'Date')
}

export function isNull(val: unknown): val is null {
  return val === null
}

export function isNullAndUnDef(val: unknown): val is null | undefined {
  return isUnDef(val) && isNull(val)
}

export function isNullOrUnDef(val: unknown): val is null | undefined {
  return isUnDef(val) || isNull(val)
}

export function isNumber(val: unknown): val is number {
  return is(val, 'Number')
}

export function isString(val: unknown): val is string {
  return is(val, 'String')
}

export function isBoolean(val: unknown): val is boolean {
  return is(val, 'Boolean')
}

export function isRegExp(val: unknown): val is RegExp {
  return is(val, 'RegExp')
}

export function isArray(val: any): val is Array<any> {
  return val && Array.isArray(val)
}

export function isWindow(val: any): val is Window {
  return typeof window !== 'undefined' && is(val, 'Window')
}

export function isElement(val: unknown): val is Element {
  return isObject(val) && !!val.tagName
}

export function isMap(val: unknown): val is Map<any, any> {
  return is(val, 'Map')
}

export const isServer = typeof window === 'undefined'

export const isClient = !isServer

export function isUrl(path: string): boolean {
  // eslint-disable-next-line regexp/no-super-linear-backtracking, regexp/no-useless-quantifier
  const reg = /(((^https?:(?:\/\/)?)(?:[-;:&=+$,\w]+@)?[A-Za-z0-9.-]+(?::\d+)?|(?:www.|[-;:&=+$,\w]+@)[A-Za-z0-9.-]+)((?:\/[+~%/.\w-]*)?\??[-+=&;%@.\w]*(?:#\w*)?)?)$/

  return reg.test(path)
}
/**
 * 判断是否为移动端
 * @returns 是否为移动端
 */
export function isMobileHelper() {
  return isMobile
}

/**
 * 获取页面导航类型
 * @returns 返回页面导航类型:
 * - reload: 页面重新加载
 * - navigate: 正常导航访问
 * - back_forward: 通过前进后退访问
 * - prerender: 预渲染
 * - undefined: 无法获取导航类型
 */
export function getEntryType(): 'reload' | 'navigate' | 'back_forward' | 'prerender' | undefined {
  // 获取导航性能记录
  const navEntries = performance.getEntriesByType('navigation')
  console.log('[helper]页面导航类型============', { navEntries })
  // 如果有导航记录则返回第一条记录的类型
  if (navEntries.length > 0) {
    return (navEntries[0] as PerformanceNavigationTiming).type
  }
  // 无导航记录返回undefined
  return undefined
}

/**
 * 判断是否为同域链接
 * @param href 链接
 * @param mustSameDomain 必须同一主域名
 * @returns 是否为同域链接
 */
export const checkIsPeerupLink = (href: string, mustSameDomain: boolean = false): boolean => {
  try {
    const currentUrl = new URL(window.location.href)
    const targetUrl = new URL(href)

    // 如果是相同的 origin，肯定是内部链接
    if (currentUrl.origin === targetUrl.origin) return true

    if (mustSameDomain) return false

    //  检查是否为同一主域名的子域名（如果需要的话）

    const currentMainDomain = getTopDomain()
    const targetMainDomain = getTopDomain(href)

    // 如果主域名相同，认为是内部链接
    return currentMainDomain === targetMainDomain
  } catch (error) {
    // URL 解析失败，保守处理为外部链接
    console.warn('URL parsing failed:', error)
    return false
  }
}
